import styled from '@emotion/styled'
import { DEFAULT_THEME_COLORS, DEFAULT_BORDER_STYLES } from 'css/theme'

// Skeleton loading for payment method selector
const PaymentSelectorSkeleton = () => {
  const skeletonItems = Array.from({ length: 3 })

  return (
    <PaymentSelectorContainer>
      <SkeletonContainer>
        {skeletonItems.map((_, index) => (
          <SkeletonItem key={index}>
            <SkeletonRadio />
            <SkeletonIcon />
            <SkeletonText />
          </SkeletonItem>
        ))}
      </SkeletonContainer>
    </PaymentSelectorContainer>
  )
}

export default PaymentSelectorSkeleton

// Skeleton styles
const SkeletonContainer = styled.div({})

const SkeletonItem = styled.div({
  height: '57px',
  display: 'flex',
  alignItems: 'center',
  padding: '16px 20px 16px 16px',
  borderBottom: `1px solid ${DEFAULT_THEME_COLORS['--theme-color--neutral-90']}`,
  backgroundColor: DEFAULT_THEME_COLORS['--theme-color--neutral-100'],

  // Remove border-bottom for the last skeleton item
  '&:last-child': {
    borderBottom: 'none',
  },
})

const SkeletonRadio = styled.div({
  width: '20px',
  height: '20px',
  borderRadius: '50%',
  backgroundColor: DEFAULT_THEME_COLORS['--theme-color--neutral-90'],
  marginRight: '10px',
})

const SkeletonText = styled.div({
  flex: 1,
  height: '18px',
  backgroundColor: DEFAULT_THEME_COLORS['--theme-color--neutral-90'],
  borderRadius: '4px',
})

const SkeletonIcon = styled.div({
  width: '30px',
  height: '20px',
  backgroundColor: DEFAULT_THEME_COLORS['--theme-color--neutral-90'],
  borderRadius: '4px',
  marginRight: '10px',
})

// Reuse the existing PaymentSelectorContainer
const PaymentSelectorContainer = styled.fieldset({
  margin: 0,
  padding: 0,
  width: '100%',
  overflow: 'hidden',
  'label:last-child': { borderBottom: 'none' },
  borderRadius: DEFAULT_BORDER_STYLES['--theme--border-radius-lg'],
  border: `1px solid ${DEFAULT_THEME_COLORS['--theme-color--neutral-90']}`,
})
